export function isClipPathForSvgsSupported() {
    if (typeof document === 'undefined') {
        return false;
    }
    // eslint-disable-next-line react-hooks-ssr/react-hooks-global-ssr
    const rectElement = document.createElement('rect');
    if (rectElement.style.clipPath === '') {
        rectElement.style.clipPath = 'polygon(50% 0%, 0% 100%, 100% 100%)';
        if (rectElement.style.clipPath !== '') {
            return true;
        }
    }
    return false;
}
